import React, { PureComponent } from "react";
import fileService from "../../services/fileService";
import MPSBarLoader from "../../components/MPSBarLoader";
import PlayIcon from "./Icons/PlayIcon";

class VideoPlayer extends PureComponent {
  static propTypes = {};

  static defaultProps = {
    ...PureComponent.defaultProps
  };

  constructor(props) {
    super(props);
    this.state = { orientation: "horizontal", aspectRatio: null };
  }

  componentDidMount() {
    fileService.getFile(this.props.thumbnailURL).then(data => {
      this.setState({ thumbnail: data });
      const img = new Image();
      img.onload = () => {
        if (!img.naturalWidth || !img.naturalHeight) return;
        this.setState({
          orientation:
            img.naturalHeight > img.naturalWidth ? "vertical" : "horizontal",
          aspectRatio: `${img.naturalWidth} / ${img.naturalHeight}`
        });
      };
      img.src = data;
    });
  }

  onClick = () => {
    this.setState({ loading: true });
    fileService
      .getFile(this.props.url)
      .then(data => {
        this.setState({ dataUrl: data, loading: false });
      })
      .catch(e => {
        this.setState({ loading: false });
      });
  };

  onLoadedMetadata = e => {
    const v = e.target;
    if (!v.videoWidth || !v.videoHeight) return;
    this.setState({
      orientation:
        v.videoHeight > v.videoWidth ? "vertical" : "horizontal",
      aspectRatio: `${v.videoWidth} / ${v.videoHeight}`
    });
  };

  render() {
    const { dataUrl, thumbnail, loading, orientation, aspectRatio } = this.state;
    const isVertical = orientation === "vertical";

    const thumbnailStyle = isVertical
      ? {
          height: "70vh",
          width: "auto",
          aspectRatio: aspectRatio || "9 / 16",
          maxWidth: "100%",
          backgroundImage: "url('" + thumbnail + "')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          borderRadius: "12px",
          backgroundRepeat: "no-repeat"
        }
      : {
          width: "100%",
          aspectRatio: aspectRatio || "16 / 9",
          maxHeight: "70vh",
          backgroundImage: "url('" + thumbnail + "')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          borderRadius: "12px",
          backgroundRepeat: "no-repeat"
        };

    const videoStyle = isVertical
      ? { height: "70vh", width: "auto", maxWidth: "100%", borderRadius: "12px" }
      : { width: "100%", height: "auto", maxHeight: "70vh", borderRadius: "12px" };

    if (!dataUrl) {
      return (
        <div
          style={{ width: "100%" }}
          className="d-flex justify-content-center align-items-center"
        >
          <div
            className={"d-flex justify-content-center align-items-center"}
            style={thumbnailStyle}
          >
            {!loading && <PlayIcon onClick={this.onClick} />}
            {loading && (
              <div style={{ margin: "100px auto", width: 50 }}>
                <MPSBarLoader />
              </div>
            )}
          </div>
        </div>
      );
    }

    return (
      <div className="d-flex justify-content-center align-items-center">
        <video
          style={videoStyle}
          controls
          preload="none"
          poster={thumbnail}
          autoPlay
          onLoadedMetadata={this.onLoadedMetadata}
        >
          <source src={dataUrl} />
          Sorry, your browser doesn't support embedded videos.
        </video>
      </div>
    );
  }
}

export default VideoPlayer;
